const styles = {
	pdfStyles: {
		nomeEmpresa: { fontSize: "11px", fontWeight: "bold", color: "#1a1a1a", fontFamily: "Helvetica" },
		dadosEmpresa: { fontSize: "9px", color: "#555555", fontFamily: "Helvetica", lineHeight: 1.3 },
		tituloPeriodo: { fontSize: "14px", fontWeight: "bold", color: "#1a1a1a", fontFamily: "Helvetica", marginBottom: "8px" },
		tituloCliente: { fontSize: "13px", fontWeight: "bold", color: "#1a1a1a", fontFamily: "Helvetica", marginBottom: "12px" },
		tituloGrafico: { fontSize: "11px", fontWeight: "bold", color: "#1a1a1a", alignment: "center", fontFamily: "Helvetica", marginBottom: "8px", textAlign: "center" },
		subtituloSecao: { fontSize: "12px", fontWeight: "bold", color: "#1a1a1a", fontFamily: "Helvetica", marginBottom: "16px" },
		textoIntro: { fontSize: "10px", color: "#333333", lineHeight: 1.5, alignment: "justify", fontFamily: "Helvetica", marginBottom: "16px", textAlign: "justify" },
		campo: { fontSize: "10px", color: "#333333", lineHeight: 1.3, fontFamily: "Helvetica" },
		fonte: { fontSize: "8px", color: "#555555", fontStyle: "italic", alignment: "center", fontFamily: "Helvetica", marginBottom: "16px", textAlign: "center" },
		rodape: { fontSize: "8px", color: "#888888", fontFamily: "Helvetica" },
	},
	tableStyles: {
		container: {
			width: "100%",
			borderCollapse: "collapse",
			margin: "0 0 16px 0",
			border: "1px solid #bfbfbf",
			fontFamily: "Helvetica, Arial, sans-serif",
		},
		headerCell: {
			padding: "4px",
			color: "#ffffff",
			backgroundColor: "#122149",
			fontSize: "10px",
			fontWeight: "bold",
			borderBottom: "1px solid #bfbfbf",
		},
		rowEven: {
			backgroundColor: "#edf1fa",
		},
		rowOdd: {
			backgroundColor: "#ffffff",
		},
		bodyCell: {
			padding: "4px",
			color: "#212B36",
			fontSize: "8px",
		},
	},
	svgContainer: {
		width: "100%",
		height: "auto", // Automatically scales height proportional to the SVG's viewBox
		aspectRatio: "900 / 200", // Force the browser to reserve proportional vertical space
		mb: 0.2,
		filter: "blur(3px)",
		display: "flex",
		justifyContent: "center",
	},
	pieSvgContainer: {
		width: "100%",
		height: "80px", // Constrains the height so the pie chart isn't massive
		mb: 0.2,
		filter: "blur(3px)",
		display: "flex",
		justifyContent: "center",
	}
};

export default styles;
